import { checkFileExtensionRegex } from 'utilities/helper.util';

export const getAttachmentData = (valueIndex: number, emailPreview: any) => {
  let id = '';
  let body = '';
  let type = '';
  let name = '';
  let isFileSupported = false;
  const filename = emailPreview.Attachments[valueIndex].name;
  const mimeType = emailPreview.Attachments[valueIndex].mimeType || 'unknown';

  // check for file extension as pdf and gml sometimes having same mimetype
  if (
    ['application/pdf', 'application/octet-stream'].includes(mimeType) &&
    checkFileExtensionRegex(filename, 'pdf')
  ) {
    isFileSupported = true;
    type = 'pdf';
  } else if (
    [
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/vnd.microsoft.icon',
      'image/svg+xml',
      'image/tiff'
    ].includes(mimeType)
  ) {
    isFileSupported = true;
    type = 'image';
  } else if (['model/vnd.dwf', 'drawing/x-dwf'].includes(mimeType)) {
    isFileSupported = !!emailPreview.isSupportDWF;
    type = 'dwf';
  } else {
    isFileSupported = false;
    type = 'unknown';
  }

  id = emailPreview.Attachments[valueIndex].id;
  body = emailPreview.Attachments[valueIndex].url;
  name = emailPreview.Attachments[valueIndex].name;
  const data = {
    id: id ? Number(id) : undefined,
    body,
    type,
    name
  };

  return {
    data,
    isFileSupported
  };
};
